import React, { useState } from "react";
import Input from "../../../ui/common/Input";
import "./ReadingTimeSettingsModal.scss";
import Button from "../../../ui/common/Button";
import ToggleSwitch from "../../../ui/toggleSwitch/ToggleSwitch";

const ReadingTimeSettingsModal = ({ data, onSave, onClose }) => {
  const [mainContent, setMainContent] = useState(data.mainContent.value || data.mainContent.default);
  const [excludeContent, setExcludeContent] = useState(data.excludeContent.value || data.excludeContent.default);

  const handleSave = () => {
    onSave({
     mainContent: {
        default: data.mainContent.default,
        value: mainContent,
      },
      excludeContent: {
        default: data.excludeContent.default,
        value: excludeContent,
      },
    });
    onClose();
  };

  return (

    <div className="readingtime-settings-modal-wrapper">

      <h4>Readingtime Settings</h4>
      <Input
        id="mainContent"
        label="Main Content"
        value={mainContent}
        onChange={(e) => {
          setMainContent(e.target.value);
        }}
        separateLines
        fullWidth
      />
      <Input
        id="excludeContent"
        label="Exclude Content"
        value={excludeContent}
        onChange={(e) => {
          setExcludeContent(e.target.value);
        }}
        separateLines
        fullWidth
      />
      <div className="sub-modal-actions">
        <Button
          variant="danger"
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </Button>
        <Button variant="success" onClick={handleSave}>
          OK
        </Button>
      </div>
    </div>
  );
};

export default ReadingTimeSettingsModal;
